import { ButtonIcon, CrossedIcon, FilterIcon, styled, Tooltip, TrashIcon } from 'canoe';
import { nanoid } from 'nanoid';
import React from 'react';
import { useDispatch } from 'react-redux';

import {
  Filter,
  FilterOperations,
  FilterTypes,
  setFilters,
  useFilters,
} from '@candu-ai/analytics/search';

const Container = styled.div`
  display: flex;
  margin-left: -12px;
  opacity: 0;
`;

interface Props {
  filterType: FilterTypes;
  value: string;
}

export const TableFilterActions = ({ filterType, value }: Props) => {
  const dispatch = useDispatch();
  const setReduxFilters = (newFilters: Filter[]) => dispatch(setFilters(newFilters));
  const filters = useFilters();

  const onFilter = (type: FilterOperations) => {
    setReduxFilters([
      ...filters,
      {
        id: nanoid(6),
        type: filterType,
        operation: {
          type,
          operand: value,
        },
      },
    ]);
  };

  const removeFilter = (filterId: string) => {
    setReduxFilters(filters.filter((filter) => filter.id !== filterId));
  };

  const foundFilter = filters.find(
    (filter) => filter.type === filterType && filter.operation.operand === value,
  );

  if (foundFilter) {
    return (
      <Container>
        <Tooltip content="Remove filter" placement="top">
          <ButtonIcon
            icon={TrashIcon}
            size="small"
            color="contrast"
            onClick={() => removeFilter(foundFilter.id)}
          />
        </Tooltip>
      </Container>
    );
  }

  return (
    <Container>
      <Tooltip content="Filter" placement="top">
        <ButtonIcon
          icon={FilterIcon}
          size="small"
          color="contrast"
          onClick={() => onFilter(FilterOperations.Equals)}
        />
      </Tooltip>
      <Tooltip content="Exclude" placement="top">
        <ButtonIcon
          icon={CrossedIcon}
          size="small"
          color="contrast"
          onClick={() => onFilter(FilterOperations.EqualsNot)}
        />
      </Tooltip>
    </Container>
  );
};
